import Home from "../pages/User/Home/Home";
import Vehicles from "../pages/User/Vehicles/Vehicles";
import Vehicle from "../pages/User/Vehicles/Vehicle/Vehicle"
import ContactUs from "../pages/User/ContactUs/ContactUs";
import AboutUs from "../pages/User/aboutUs/AboutUs";
import HowToBuy from "../pages/User/howToBuy/HowToBuy";

var UserRoutes = [
    {
        path: "/",
        name: "Home",
        element: <Home />
    },
    {
        path: "/vehicles",
        name: "Vehicles",
        element: <Vehicles />
    },
    {
        path: "/contact-us",
        name: "Contact Us",
        element: <ContactUs />
    },
    {
        path: "/about-us",
        name: "About Us",
        element: <AboutUs />
    },
    {
        path: "/how-to-buy",
        name: "How To Buy",
        element: <HowToBuy />
    },
    {
        path: "/vehicles/:id",
        name: "Vehicle",
        element: <Vehicle />
    },
];
export default UserRoutes;
